<template>
  <div>
    <div class="mb-3">
      <h2 class="m-0">Dilazioni</h2>
    </div>

    <div class="card">
      <loader v-if="dataLoading" style="z-index: 1101" />

      <div v-if="!hideControls" class="formgrid grid align-items-center">
        <div class="field col-12 xl:col-7">
          <MultiSelect
            v-model="selectedClients"
            :options="clients"
            :filter="true"
            :filterFields="['cliente', 'rappresentante']"
            optionLabel="cliente"
            placeholder="Seleziona cliente"
            class="inputfield w-full"
          >
            <template #option="slotProps">
              <div class="flex align-items-center">
                <div>{{ slotProps.option.cliente }} ({{ slotProps.option.num_dilazioni }}) - {{ slotProps.option.rappresentante }}</div>
              </div>
            </template>
            <template #footer>
              <div class="py-2 px-3">
                <b>{{ selectedClients ? selectedClients.length : 0 }}</b> client{{ (selectedClients ? selectedClients.length : 0) > 1 ? 'i' : 'e' }} selezionati.
              </div>
            </template>
          </MultiSelect>
        </div>

        <div class="field col-9 xl:col-3 flex align-items-center justify-content-center">
          Dilazioni attive
          <InputSwitch class="m-2" v-model="view_all" @change="getClientHasDilazioni()" />
          Tutte le dilazioni
        </div>

        <div class="field col-3 xl:col-2">
          <Button icon="pi pi-search" @click="getAllDilazioni" class="w-full" label="Cerca" />
        </div>
      </div>

      <accordion :multiple="true">
        <accordion-tab v-for="dilazione of data.filtered" :key="dilazione.id">
          <template #header>
            <span>{{ dilazione.cliente.ragsoc }} - Numero rate: {{ dilazione.numero_rate }} - Totale dilazione: {{ currencyFormatter.format(dilazione.importo) }} - Importo pagato: {{ currencyFormatter.format(dilazione.pagato) }} - Data creazione: {{ moment(dilazione.data_creazione).format('DD/MM/YYYY') }}</span>
          </template>

          <div class="formgrid grid">
            <div class="field col-12 flex align-items-end">
              <label class="mr-2 mb-3">Stato:</label>
              <h4 :style="`color: ${dilazione.color}; font-weight: 600`">{{ dilazione.name_state }}</h4>
            </div>

            <div class="field col-12 md:col-4">
              <label for="data_creazione" class="mr-2">Data creazione</label>
              <calendar
                id="data_creazione"
                v-model="dilazione.data_creazione"
                :showIcon="true"
                dateFormat="dd/mm/yy"
                :disabled="true"
                class="inputfield w-full"
              />
            </div>

            <div class="field col-12 md:col-4">
              <label for="importo" class="mr-2">Importo Dilazione</label>
              <input-number
                id="importo"
                v-model="dilazione.importo"
                mode="currency"
                currency="EUR"
                locale="it-IT"
                :disabled="true"
                class="inputfield w-full"
              />
            </div>

            <div class="field col-12 md:col-4">
              <label for="numero_rate" class="mr-2">Numero Rate</label>
              <prime-input-text
                id="numero_rate"
                v-model="dilazione.numero_rate"
                type="text"
                :disabled="true"
                class="inputfield w-full"
              />
            </div>

            <div class="field col-12 md:col-4">
              <label for="ragsoc" class="mr-2">Cliente</label>
              <router-link
                :to="`/ask/clienti/${dilazione.cliente.id}/dettagli`"
                custom
                v-slot="{ href }"
              >
                <prime-button
                  :label="`${dilazione.cliente.ragsoc}`"
                  class="p-button-info p-button-text w-full"
                  @click="navigateToTab(href)"
                />
              </router-link>
            </div>

            <div class="field col-12 md:col-4">
              <label for="pagato" class="mr-2">Importo Pagato</label>
              <input-number
                id="pagato"
                v-model="dilazione.pagato"
                mode="currency"
                currency="EUR"
                locale="it-IT"
                :disabled="true"
                class="inputfield w-full"
              />
            </div>

            <div class="field col-12 md:col-4">
              <label for="creata_da" class="mr-2">Creata da</label>
              <prime-input-text
                id="creata_da"
                v-model="dilazione.creata_da"
                type="text"
                :disabled="true"
                class="inputfield w-full"
              />
            </div>

            <accordion :multiple="true" class="w-full">
              <accordion-tab header="Rate">
                <data-table :value="dilazione.rate" responsiveLayout="scroll">
                  <column field="data" header="Data Pagamento">
                    <template #body="{ data }">
                      {{ data.data !== null ? moment(data.data).format('DD/MM/YYYY') : '' }}
                    </template>
                  </column>
                  <column field="importo" header="Importo">
                    <template #body="{ data }">
                      {{ currencyFormatter.format(data.importo !== null ? data.importo : 0) }}
                    </template>
                  </column>
                  <column field="isPagato" header="Pagata">
                    <template #body="{ data }">
                      {{ data.isPagato ? 'SI' : 'NO' }}
                    </template>
                  </column>
                </data-table>
              </accordion-tab>

              <accordion-tab header="Fatture">
                <data-table :value="dilazione.fatture" responsiveLayout="scroll">
                  <column field="numero" header="Numero"></column>
                  <column field="data_emissione" header="Data Emissione">
                    <template #body="{ data }">
                      {{ data.data !== null ? moment(data.data_emissione).format('DD/MM/YYYY') : '' }}
                    </template>
                  </column>
                  <column field="data_scadenza" header="Data Scadenza">
                    <template #body="{ data }">
                      {{ data.data !== null ? moment(data.data_scadenza).format('DD/MM/YYYY') : '' }}
                    </template>
                  </column>
                  <column field="totale_fattura" header="Totale Fattura">
                    <template #body="{ data }">
                      {{ currencyFormatter.format(data.totale_fattura !== null ? data.totale_fattura : 0) }}
                    </template>
                  </column>
                  <column field="saldo" header="Saldo">
                    <template #body="{ data }">
                      {{ currencyFormatter.format(data.saldo !== null ? data.saldo : 0) }}
                    </template>
                  </column>
                </data-table>
              </accordion-tab>
            </accordion>
          </div>

          <Fieldset legend="Firma OTP" :toggleable="true">
            <prime-button
              v-if="!dilazione.cod_richiesta_firma"
              label="Richiedi firma dilazione"
              icon="pi pi-send"
              class="p-ml-auto m-1"
              @click="openDetailSignDilazione(dilazione.id)"
              :disabled="isDisableSignPdf"
            />

            <div v-else class="flex flex-wrap justify-content-around">
              <div class="col-12 flex h-4rem">
                <div class="col-4 flex justify-content-center" v-if="dilazione.data_annullamento">
                  <InlineMessage severity="error">Documento annullato</InlineMessage>
                </div>
                <div class="col-4 flex justify-content-center" v-else-if="!dilazione.is_complete">
                  <InlineMessage severity="info">Documento in attesa di firma</InlineMessage>
                </div>
                <div class="col-4 flex justify-content-center" v-else>
                  <InlineMessage severity="success">Documento firmato</InlineMessage>
                </div>
                <div class="col-2"></div>
                <div class="col-6 flex flex-wrap justify-content-end">
                  <prime-button
                    v-if="dilazione.data_firma"
                    label="Scarica documento"
                    icon="pi pi-download"
                    class="p-ml-auto m-1 p-button-success"
                    @click="downloadPdf(dilazione.id)"
                  />
                  <prime-button
                    v-if="dilazione.data_firma"
                    label="Scarica report di firma"
                    icon="pi pi-download"
                    class="p-ml-auto m-1 p-button-success"
                    @click="downloadPdf(dilazione.id, 'report')"
                  />
                  <prime-button
                    v-if="!dilazione.data_annullamento && !dilazione.data_firma"
                    label="Annulla firma dilazione"
                    icon="pi pi-trash"
                    class="p-ml-auto m-1 p-button-danger"
                    @click="openConfirmDeleteSignDilazione(dilazione.id)"
                    :disabled="isDisableDeleteSign"
                  />
                </div>
              </div>

              <Fieldset legend="Dettagli" class="w-full">
                <div class="flex flex-wrap justify-content-around">
                  <div>
                    <label>Nominativo di firma</label>
                    <h6>{{ dilazione.nominativo }}</h6>
                  </div>
                  <div>
                    <label>Contatto di firma</label>
                    <h6>{{ dilazione.contatto }}</h6>
                  </div>
                  <div>
                    <label>Email di firma</label>
                    <h6>{{ dilazione.email_firma }}</h6>
                  </div>
                  <div>
                    <label>{{ dilazione.stato_documento }} il</label>
                    <h6>{{ moment(getDataStatusDilazione(dilazione)).format('DD/MM/YYYY HH:mm') }}</h6>
                  </div>
                </div>
              </Fieldset>
            </div>
          </Fieldset>

          <div class="flex p-3 pl-0">
            <prime-button
              label="Cancella Dilazione"
              icon="pi pi-file-o"
              class="p-ml-auto m-1 p-button-danger"
              @click="confirmDelete($event, dilazione.id)"
            />

            <prime-button
              label="Scarica XML RID"
              icon="pi pi-file-o"
              class="p-ml-auto m-1"
              @click="onXmlRidDilazione(dilazione.id)"
            />

            <prime-button
              label="Bollettini Postali"
              icon="pi pi-file-o"
              class="p-ml-auto m-1"
              @click="onBollettiniPostaliDilazione(dilazione.id)"
            />

            <prime-button
              label="PDF Lettera Accettazione"
              icon="pi pi-download"
              class="p-ml-auto m-1"
              @click="onPdfLetteraAccettazioneDilazione(dilazione.id)"
            />

            <prime-button
              label="Invia Mail PDF Lettera Accettazione"
              icon="pi pi-send"
              class="p-ml-auto m-1"
              @click="openDialogMailDilazioni(dilazione)"
            />
          </div>

          <div class="flex p-3 pl-0">
            <prime-button
              v-if="dilazione.active != -1"
              label="Archivia dilazione"
              icon="pi pi-cloud-upload"
              class="p-ml-auto m-1 p-button-danger"
              @click="changeStatusDilazione(dilazione, -1)"
            />
            <prime-button
              v-if="dilazione.active != 0"
              label="Attiva dilazione"
              icon="pi pi-cloud-upload"
              class="p-ml-auto m-1 p-button-success"
              @click="changeStatusDilazione(dilazione, 0)"
            />
            <prime-button
              v-if="dilazione.active != 1"
              label="Salda dilazione"
              icon="pi pi-cloud-upload"
              class="p-ml-auto m-1"
              @click="changeStatusDilazione(dilazione, 1)"
            />
          </div>
        </accordion-tab>
      </accordion>
    </div>

    <Dialog v-model:visible="dialogDilazioniMail" modal header="Invia Mail PDF Lettera Accettazione" :style="{ width: '90vw' }">
      <div v-if="tempDilazioneMail" class="formgrid grid">
        <div class="field col-12 md:col-2">
          <label class="mr-2">Email/Pec</label>
          <prime-dropdown
            v-model="tempDilazioneMail.type_comunication"
            :options="typesComunicationDilazione"
            optionLabel="label"
            optionValue="label"
            placeholder="Seleziona..."
            class="inputfield w-full"
          />
        </div>
        <div class="field col-12 md:col-5">
          <label for="email" class="mr-2">Invia a</label>
          <prime-dropdown
            id="email"
            v-model="tempDilazioneMail.cliente.email"
            :options="mailsDilazione"
            optionLabel="to"
            optionValue="to"
            placeholder="Seleziona..."
            class="inputfield w-full"
            editable
          />
        </div>
        <div class="field col-12 md:col-5">
          <label for="type_mail_dilazione" class="mr-2">Tipo Dilazione</label>
          <prime-dropdown
            id="type_mail_dilazione"
            v-model="tempDilazioneMail.type_mail_dilazione"
            :options="typesMailDilazione"
            optionLabel="label"
            optionValue="label"
            placeholder="Seleziona..."
            class="inputfield w-full"
          />
        </div>
      </div>
      <div v-else>
        Nessuna dilazione selezionata
      </div>
      <template #footer>
        <Button label="Chiudi" icon="pi pi-times" @click="dialogDilazioniMail = false" class="p-button-text p-button-secondary" />
        <Button label="Invia" icon="pi pi-check" class="p-button-text" @click="sendMailDilazione" />
      </template>
    </Dialog>

    <Dialog v-model:visible="viewDialogDetailSignDilazione" modal header="Dettagli della richiesta di firma" :style="{ width: '50%' }">
      <div class="flex justify-content-around">
        <div class="col-12 md:col-4 flex flex-wrap">
          <label class="col-12">Nome e cognome</label>
          <InputText type="text" v-model="detailSignDilazione.nominativo" />
        </div>
        <div class="col-12 md:col-4 flex flex-wrap">
          <label class="col-12">Email</label>
          <InputText type="text" v-model="detailSignDilazione.email" />
        </div>
        <div class="col-12 md:col-4 flex flex-wrap">
          <label class="col-12">Cellulare</label>
          <InputText type="text" v-model="detailSignDilazione.contatto" />
        </div>
      </div>
      <template #footer>
        <Button label="Chiudi" icon="pi pi-times" @click="viewDialogDetailSignDilazione = false" class="p-button-text p-button-secondary" />
        <Button label="Invia" icon="pi pi-check" class="p-button-text" @click="sendSignRequestDilazione(detailSignDilazione)" :disabled="!detailSignDilazione.nominativo || !detailSignDilazione.contatto || !detailSignDilazione.email" />
      </template>
    </Dialog>

    <Dialog v-model:visible="viewConfirmDeleteSignDilazione" modal header="Annulla la richiesta di firma" :style="{ width: '50%' }">
      <div class="formgrid grid">
        <h3>Vuoi annullare la richiesta di firma?</h3>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" @click="viewConfirmDeleteSignDilazione = false" class="p-button-text p-button-secondary" />
        <Button label="Si" icon="pi pi-check" class="p-button-text" @click="sendDeleteSignRequestDilazione(detailSignDilazione)" />
      </template>
    </Dialog>

    <div class="mt-3">
      <div class="card">
        <TabView :activeIndex="activeStatsTab" @tab-change="onStatsTabChange">
          <TabPanel header="Rate in Scadenza">
            <div class="flex align-items-center justify-content-between mb-3">
              <h3 class="m-0">Rate in scadenza</h3>
              <Button
                icon="pi pi-refresh"
                label="Aggiorna"
                class="p-button-text"
                @click="resetRateDilazioniScadenzaTable"
              />
            </div>

            <div class="formgrid grid align-items-end">
              <div class="field col-12 xl:col-3">
                <label>Periodo rate</label>
                <Calendar
                  v-model="rateScadenzaFilters.range"
                  selectionMode="range"
                  :showIcon="true"
                  dateFormat="dd/mm/yy"
                  class="inputfield w-full"
                />
              </div>

              <div class="field col-12 xl:col-2" hidden>
                <label>Stato rata</label>
                <Dropdown
                  v-model="rateScadenzaFilters.is_saldata"
                  :options="[
                    { label: 'Tutte', value: null },
                    { label: 'Saldate', value: 1 },
                    { label: 'Non saldate', value: 0 }
                  ]"
                  optionLabel="label"
                  optionValue="value"
                  class="inputfield w-full"
                  @change="onRateScadenzaSearch"
                />
              </div>

              <div class="field col-12 xl:col-4">
                <label>Cerca</label>
                <prime-input-text
                  v-model="rateScadenzaTable.search"
                  class="inputfield w-full"
                  placeholder="Cerca per codice, piva, codfis, cliente, rappresentante, importo"
                  @keyup.enter="onRateScadenzaSearch"
                />
              </div>

              <div class="field col-6 xl:col-1">
                <Button
                  icon="pi pi-search"
                  class="w-full"
                  @click="onRateScadenzaSearch"
                />
              </div>

              <div class="field col-6 xl:col-2">
                <Button
                  icon="pi pi-times"
                  label="Reset"
                  class="w-full p-button-secondary"
                  @click="resetRateDilazioniScadenzaTable"
                />
              </div>
            </div>

            <DataTable
              :value="rateScadenzaRows"
              responsiveLayout="scroll"
              :lazy="true"
              :paginator="true"
              :rows="rateScadenzaTable.rows"
              :rowsPerPageOptions="[25, 50, 100, 150]"
              :first="rateScadenzaTable.first"
              :totalRecords="rateScadenzaTable.totalRecords"
              :loading="rateScadenzaTable.loading"
              :sortField="rateScadenzaTable.sortField"
              :sortOrder="rateScadenzaTable.sortOrder"
              @page="onRateScadenzaPage"
              @sort="onRateScadenzaSort"
            >
              <Column field="code" header="Codice Cliente" sortable />

              <Column field="piva" header="P.IVA" sortable />
              <Column field="codfis" header="Cod. Fiscale" sortable />
              <Column field="cliente" header="Cliente" sortable />
              <Column field="rappresentante" header="Rappresentante" sortable />
              <Column field="indirizzo" header="Indirizzo" sortable />
              <Column field="importo" header="Importo" sortable>
                <template #body="{ data }">
                  {{ currencyFormatter.format((data.importo !== null && data.importo !== undefined) ? data.importo : 0) }}
                </template>
              </Column>
              <Column field="numeri_fattura" header="Numeri Fattura" />
              <Column field="data_dilazione_rata" header="Data scadenza" sortable>
                <template #body="{ data }">
                  {{ data.data_dilazione_rata ? moment(data.data_dilazione_rata).format('DD/MM/YYYY') : '' }}
                </template>
              </Column>
              <Column field="gestito_da" header="Gestita da" sortable></Column>
              <Column field="forniture_attive" header="Attive" sortable>
                <template #body="{ data }">
                  <Tag
                    :value="String(data.forniture_attive ?? 0)"
                    severity="success"
                  />
                </template>
              </Column>

              <Column field="forniture_cessate" header="Cessate" sortable>
                <template #body="{ data }">
                  <Tag
                    :value="String(data.forniture_cessate ?? 0)"
                    severity="danger"
                  />
                </template>
              </Column>

              <Column field="forniture_altro_stato" header="Altro stato" sortable>
                <template #body="{ data }">
                  <Tag
                    :value="String(data.forniture_altro_stato ?? 0)"
                    severity="warning"
                  />
                </template>
              </Column>
              <Column header="Forniture">
                <template #body="{ data }">
                  <Button
                    icon="pi pi-list"
                    label="Vedi"
                    class="p-button-sm p-button-info"
                    @click="openFornitureDialog(data)"
                  />
                </template>
              </Column>
              <Column field="is_saldata" header="Saldata" sortable hidden>
                <template #body="{ data }">
                  <Tag
                    :value="Number(data.is_saldata) === 1 ? 'Sì' : 'No'"
                    :severity="Number(data.is_saldata) === 1 ? 'success' : 'danger'"
                  />
                </template>
              </Column>
            </DataTable>

            <Dialog
              v-model:visible="viewFornitureDialog"
              modal
              header="Forniture cliente"
              :style="{ width: '70vw' }"
            >
              <div v-if="selectedFornitureRow">
                <h4 class="mb-3">
                  {{ selectedFornitureRow.cliente }}
                </h4>

                <div class="grid">
                  <div class="col-12 md:col-6">
                    <h5>POD</h5>

                    <DataTable
                      :value="selectedFornitureRow.pod_forniture || []"
                      responsiveLayout="scroll"
                    >
                      <Column field="code" header="POD" />
                      <Column field="stato" header="Stato" />
                    </DataTable>
                  </div>

                  <div class="col-12 md:col-6">
                    <h5>PDR</h5>

                    <DataTable
                      :value="selectedFornitureRow.pdr_forniture || []"
                      responsiveLayout="scroll"
                    >
                      <Column field="code" header="PDR" />
                      <Column field="stato" header="Stato" />
                    </DataTable>
                  </div>
                </div>
              </div>

              <template #footer>
                <Button
                  label="Chiudi"
                  icon="pi pi-times"
                  class="p-button-text p-button-secondary"
                  @click="viewFornitureDialog = false"
                />
              </template>
            </Dialog>
          </TabPanel>

          <TabPanel header="Dilazioni Firmate">
            <div class="flex align-items-center justify-content-between mb-3">
              <h3 class="m-0">Dilazioni firmate</h3>
              <Button
                icon="pi pi-refresh"
                label="Aggiorna"
                class="p-button-text"
                @click="resetDilazioniFirmateTable"
              />
            </div>

            <div class="formgrid grid align-items-end">
              <div class="field col-12 xl:col-3">
                <label>Da (entro quanti giorni indietro)</label>
                <Calendar
                  v-model="dilazioniFirmateFilters.range"
                  selectionMode="range"
                  :showIcon="true"
                  dateFormat="dd/mm/yy"
                  class="inputfield w-full"
                />
              </div>

              <div class="field col-12 xl:col-6">
                <label>Cerca</label>
                <prime-input-text
                  v-model="dilazioniFirmateTable.search"
                  class="inputfield w-full"
                  placeholder="Cerca per codice, piva, codfis, cliente, rappresentante, importo"
                  @keyup.enter="onDilazioniFirmateSearch"
                />
              </div>

              <div class="field col-6 xl:col-1">
                <Button
                  icon="pi pi-search"
                  class="w-full"
                  @click="onDilazioniFirmateSearch"
                />
              </div>

              <div class="field col-6 xl:col-2">
                <Button
                  icon="pi pi-times"
                  label="Reset"
                  class="w-full p-button-secondary"
                  @click="resetDilazioniFirmateTable"
                />
              </div>
            </div>

            <DataTable
              :value="dilazioniFirmateRows"
              responsiveLayout="scroll"
              :lazy="true"
              :paginator="true"
              :rows="dilazioniFirmateTable.rows"
              :rowsPerPageOptions="[25, 50, 100, 150]"
              :first="dilazioniFirmateTable.first"
              :totalRecords="dilazioniFirmateTable.totalRecords"
              :loading="dilazioniFirmateTable.loading"
              :sortField="dilazioniFirmateTable.sortField"
              :sortOrder="dilazioniFirmateTable.sortOrder"
              @page="onDilazioniFirmatePage"
              @sort="onDilazioniFirmateSort"
            >
              <Column field="code" header="Codice Cliente" sortable />
              <Column field="piva" header="P.IVA" sortable />
              <Column field="codfis" header="Cod. Fiscale" sortable />
              <Column field="cliente" header="Cliente" sortable />
              <Column field="rappresentante" header="Rappresentante" sortable />
              <Column field="indirizzo" header="Indirizzo" sortable />
              <Column field="importo" header="Importo" sortable>
                <template #body="{ data }">
                  {{ currencyFormatter.format((data.importo !== null && data.importo !== undefined) ? data.importo : 0) }}
                </template>
              </Column>
              <Column field="rata_singola" header="Singola Rata" sortable />
              <Column field="numeri_fattura" header="Numeri Fattura" />
              <Column field="data_scadenza" header="Data Scadenza" sortable>
                <template #body="{ data }">
                  {{ data.data_scadenza ? moment(data.data_scadenza).format('DD/MM/YYYY') : '' }}
                </template>
              </Column>
              <Column field="data_firma" header="Data Firma" sortable>
                <template #body="{ data }">
                  {{ data.data_firma ? moment(data.data_firma).format('DD/MM/YYYY') : '' }}
                </template>
              </Column>
            </DataTable>
          </TabPanel>
        </TabView>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import Service from '@/services/ask-management/dilazioni-service'

import Loader from '@/components/Loader.vue'
import PrimeButton from 'primevue/button'
import Button from 'primevue/button'
import PrimeInputText from 'primevue/inputtext'
import InputText from 'primevue/inputtext'
import PrimeDropdown from 'primevue/dropdown'
import Calendar from 'primevue/calendar'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import MultiSelect from 'primevue/multiselect'
import InputSwitch from 'primevue/inputswitch'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import InputNumber from 'primevue/inputnumber'
import Dialog from 'primevue/dialog'
import Fieldset from 'primevue/fieldset'
import InlineMessage from 'primevue/inlinemessage'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import { useConfirm } from "primevue/useconfirm";
import Tag from 'primevue/tag'

export default { 
  props: {
    clientIds: {
      type: Array,
      default: () => []
    },
    hideControls: {
      type: Boolean,
      default: false
    }
  },
  
  components: {
    Loader,
    PrimeButton,
    Button,
    PrimeInputText,
    InputText,
    PrimeDropdown,
    Calendar,
    DataTable,
    Column,
    MultiSelect,
    InputSwitch,
    TabView,
    TabPanel,
    accordion: Accordion,
    'accordion-tab': AccordionTab,
    'input-number': InputNumber,
    Dialog,
    Fieldset,
    InlineMessage,
    Tag
  },

  data() {
    return {
      moment,

      currencyFormatter: new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      }),

      dataLoading: false,
      filter: '',
      clients: [],
      selectedClients: [],

      activeStatsTab: 0,
      loadedStatsTabs: {
        rateScadenza: false,
        dilazioniFirmate: false,
      },

      rateScadenzaFilters: {
        range: [moment().toDate(), moment().add(7, 'days').toDate()],
        is_saldata: 0,
      },

      dilazioniFirmateFilters: {
        range: [moment().subtract(30, 'days').toDate(), moment().toDate()],
      },

      rateScadenzaRows: [],
      dilazioniFirmateRows: [],

      rateScadenzaTable: {
        page: 1,
        rows: 50,
        first: 0,
        totalRecords: 0,
        search: '',
        sortField: 'data_dilazione_rata',
        sortOrder: 1,
        loading: false,
      },

      dilazioniFirmateTable: {
        page: 1,
        rows: 50,
        first: 0,
        totalRecords: 0,
        search: '',
        sortField: 'data_firma',
        sortOrder: -1,
        loading: false,
      },

      tempDilazioneMail: null,
      dialogDilazioniMail: false,
      mailsDilazione: [],
      allTypesMailDilazione: [
        {label: 'Bonifico', for: ['all', 'Cessata']},
        {label: 'Bonifico Sdd', for: ['all']},
        {label: 'Titoli', for: ['all']},
      ],
      typesMailDilazione: [],
      typesComunicationDilazione: [
        {label: 'email'},
        {label: 'pec'},
      ],
      type_state: [],
      data: {
        dilazioni: [],
        filtered: [],
      },
      view_all: false,
      isDisableSignPdf: false,
      isDisableDeleteSign: false,
      detailSignDilazione: {
        id: null,
        nominativo: null,
        contatto: null,
        email: null
      },
      viewDialogDetailSignDilazione: false,
      viewConfirmDeleteSignDilazione: false,
      types_stato: [
        {stato: null, type_data: null},
        {stato: 1, type_data: 'creazione', name: 'Documento creato'},
        {stato: 2, type_data: 'invio', name: 'Documento inviato'},
        {stato: 3, type_data: 'firma', name: 'Documento firmato'},
        {stato: 4, type_data: 'annullamento', name: 'Documento annullato'}
      ],
      user: JSON.parse(atob(localStorage.getItem('user'))).user[0],
      confirm: useConfirm(),

      selectedFornitureRow: null,
      viewFornitureDialog: false,
    }
  },

  created(){
    this.service = new Service(this.$http, this.$eventBus)
    this.getTypeStateDilazioni()
    
    if (!this.hideControls) {
      this.getClientHasDilazioni()
    } else if (this.clientIds && this.clientIds.length > 0) {
      this.selectedClients = this.clientIds.map(id => ({ id }))
      this.$nextTick(() => {
        this.getAllDilazioni()
      })
    }

    this.loadActiveStatsTab()
  },
  
  watch: {
    filter(newVal) {
      this.applyFilter(newVal)
    },
    clientIds: {
      handler(newClientIds) {
        if (this.hideControls && newClientIds && newClientIds.length > 0 && this.service) {
          this.selectedClients = newClientIds.map(id => ({ id }))
          this.getAllDilazioni()
        }
      },
      immediate: false
    }
  },

  methods: {
    _resolveGiorniFromCalendar(toDate, defaultGiorni) {
      if (!toDate) {
        return defaultGiorni
      }

      const start = moment().startOf('day')
      const end = moment(toDate).startOf('day')
      const diff = end.diff(start, 'days')

      return diff >= 0 ? diff : defaultGiorni
    },

    _resolveGiorniFromCalendarPast(fromDate, defaultGiorni) {
      if (!fromDate) {
        return defaultGiorni
      }

      const start = moment(fromDate).startOf('day')
      const end = moment().startOf('day')
      const diff = end.diff(start, 'days')

      return diff >= 0 ? diff : defaultGiorni
    },

    _normalizeSortOrder(order) {
      return order === -1 ? 'desc' : 'asc'
    },

    loadActiveStatsTab() {
      if (this.activeStatsTab === 0 && !this.loadedStatsTabs.rateScadenza) {
        this.getRateDilazioniScadenzaList()
        this.loadedStatsTabs.rateScadenza = true
      }

      if (this.activeStatsTab === 1 && !this.loadedStatsTabs.dilazioniFirmate) {
        this.getDilazioniFirmateList()
        this.loadedStatsTabs.dilazioniFirmate = true
      }
    },

    onStatsTabChange(event) {
      this.activeStatsTab = event.index
      this.loadActiveStatsTab()
    },

    getRateDilazioniScadenzaList() {
      this.rateScadenzaTable.loading = true

      const [from, to] = this.rateScadenzaFilters.range || []

      const dataInizio = from
        ? moment(from).format('YYYY-MM-DD')
        : moment().format('YYYY-MM-DD')

      const dataFine = to
        ? moment(to).format('YYYY-MM-DD')
        : moment().add(7, 'days').format('YYYY-MM-DD')

      this.service.getRateDilazioniScadenza({
        data_inizio: dataInizio,
        data_fine: dataFine,
        is_saldata: this.rateScadenzaFilters.is_saldata,
        page: this.rateScadenzaTable.page,
        per_page: this.rateScadenzaTable.rows,
        search: this.rateScadenzaTable.search,
        sort_field: this.rateScadenzaTable.sortField,
        sort_order: this._normalizeSortOrder(this.rateScadenzaTable.sortOrder),
      })
      .then((res) => {
        this.rateScadenzaRows = res.items || []
        this.rateScadenzaTable.totalRecords = res.pagination?.total || 0
        this.rateScadenzaTable.page = res.pagination?.current_page || 1
        this.rateScadenzaTable.rows = res.pagination?.per_page || this.rateScadenzaTable.rows
        this.rateScadenzaTable.first = ((this.rateScadenzaTable.page - 1) * this.rateScadenzaTable.rows)
      })
      .catch(() => {
        this.rateScadenzaRows = []
        this.rateScadenzaTable.totalRecords = 0
      })
      .finally(() => {
        this.rateScadenzaTable.loading = false
      })
    },

    getDilazioniFirmateList() {
      this.dilazioniFirmateTable.loading = true

      const [from, to] = this.dilazioniFirmateFilters.range || []

      const dataInizio = from
        ? moment(from).format('YYYY-MM-DD')
        : moment().subtract(30, 'days').format('YYYY-MM-DD')

      const dataFine = to
        ? moment(to).format('YYYY-MM-DD')
        : moment().format('YYYY-MM-DD')

      this.service.getDilazioniFirmate({
        data_inizio: dataInizio,
        data_fine: dataFine,
        page: this.dilazioniFirmateTable.page,
        per_page: this.dilazioniFirmateTable.rows,
        search: this.dilazioniFirmateTable.search,
        sort_field: this.dilazioniFirmateTable.sortField,
        sort_order: this._normalizeSortOrder(this.dilazioniFirmateTable.sortOrder),
      })
      .then((res) => {
        this.dilazioniFirmateRows = res.items || []
        this.dilazioniFirmateTable.totalRecords = res.pagination?.total || 0
        this.dilazioniFirmateTable.page = res.pagination?.current_page || 1
        this.dilazioniFirmateTable.rows = res.pagination?.per_page || this.dilazioniFirmateTable.rows
        this.dilazioniFirmateTable.first = ((this.dilazioniFirmateTable.page - 1) * this.dilazioniFirmateTable.rows)
      })
      .catch(() => {
        this.dilazioniFirmateRows = []
        this.dilazioniFirmateTable.totalRecords = 0
      })
      .finally(() => {
        this.dilazioniFirmateTable.loading = false
      })
    },

    onRateScadenzaPage(event) {
      this.rateScadenzaTable.page = Math.floor(event.first / event.rows) + 1
      this.rateScadenzaTable.rows = event.rows
      this.rateScadenzaTable.first = event.first
      this.getRateDilazioniScadenzaList()
    },

    onRateScadenzaSort(event) {
      this.rateScadenzaTable.sortField = event.sortField || 'data_dilazione_rata'
      this.rateScadenzaTable.sortOrder = event.sortOrder || 1
      this.rateScadenzaTable.page = 1
      this.rateScadenzaTable.first = 0
      this.getRateDilazioniScadenzaList()
    },

    onRateScadenzaSearch() {
      this.rateScadenzaTable.page = 1
      this.rateScadenzaTable.first = 0
      this.getRateDilazioniScadenzaList()
    },

    resetRateDilazioniScadenzaTable() {
      this.rateScadenzaFilters.range = [
        moment().toDate(),
        moment().add(7, 'days').toDate()
      ]
      this.rateScadenzaTable.search = ''
      this.rateScadenzaFilters.is_saldata = 0
      this.rateScadenzaTable.page = 1
      this.rateScadenzaTable.rows = 50
      this.rateScadenzaTable.first = 0
      this.rateScadenzaTable.sortField = 'data_dilazione_rata'
      this.rateScadenzaTable.sortOrder = 1
      this.loadedStatsTabs.rateScadenza = true
      this.getRateDilazioniScadenzaList()
    },

    onDilazioniFirmatePage(event) {
      this.dilazioniFirmateTable.page = Math.floor(event.first / event.rows) + 1
      this.dilazioniFirmateTable.rows = event.rows
      this.dilazioniFirmateTable.first = event.first
      this.getDilazioniFirmateList()
    },

    onDilazioniFirmateSort(event) {
      this.dilazioniFirmateTable.sortField = event.sortField || 'data_firma'
      this.dilazioniFirmateTable.sortOrder = event.sortOrder || -1
      this.dilazioniFirmateTable.page = 1
      this.dilazioniFirmateTable.first = 0
      this.getDilazioniFirmateList()
    },

    onDilazioniFirmateSearch() {
      this.dilazioniFirmateTable.page = 1
      this.dilazioniFirmateTable.first = 0
      this.getDilazioniFirmateList()
    },

    resetDilazioniFirmateTable() {
      this.dilazioniFirmateFilters.range = [
        moment().subtract(30, 'days').toDate(),
        moment().toDate()
      ]
      this.dilazioniFirmateTable.search = ''
      this.dilazioniFirmateTable.page = 1
      this.dilazioniFirmateTable.rows = 50
      this.dilazioniFirmateTable.first = 0
      this.dilazioniFirmateTable.sortField = 'data_firma'
      this.dilazioniFirmateTable.sortOrder = -1
      this.loadedStatsTabs.dilazioniFirmate = true
      this.getDilazioniFirmateList()
    },

    getClientHasDilazioni(){
      this.dataLoading = true
      this.service.getClientHasDilazioni(this.view_all)
      .then((res) => {
        this.clients = res.items
      })
      .finally(() => {
        this.dataLoading = false
      })
    },
    
    confirmDelete (event, dilazioneId) {
      this.confirm.require({
          target: event.currentTarget,
          message: 'Vuoi davvero eliminare la dilazione?',
          icon: 'pi pi-info-circle',
          rejectClass: 'p-button-secondary p-button-outlined p-button-sm',
          acceptClass: 'p-button-danger p-button-sm',
          rejectLabel: 'No',
          acceptLabel: 'Si',
          accept: () => {
            this.onDeleteDilazione(dilazioneId)
            this.$toast.add({ severity: 'info', summary: 'Confermato', detail: 'Dilazione cancellata', life: 3000 });
          },
          reject: () => {
            // this.$toast.add({ severity: 'error', summary: 'Annullato', detail: 'You have rejected', life: 3000 });
          }
      });
    },

    onDeleteDilazione(dilazioneId){
      this.service.deleteDilazione(dilazioneId).then((res) => {
        if(res.success){
          this.data.dilazioni = this.data.dilazioni.filter((el) => el.id != dilazioneId)

          this.applyFilter(this.filter)
          
          this.$eventBus.emit('dilazione-cancellata', {
            type: 'dilazione-cancellata',
            success: true,
            dilazioneId: dilazioneId
          })
        }
      })
    },

    onXmlRidDilazione(dilazioneId){
      this.service.downloadXmlRid(dilazioneId)
    },

    onPdfLetteraAccettazioneDilazione(dilazioneId){
      this.service.downloadPdfLetteraAccettazione(dilazioneId)
    },

    openDetailSignDilazione(dilazioneId){
      this.detailSignDilazione.id = dilazioneId
      this.detailSignDilazione.nominativo = null
      this.detailSignDilazione.contatto = null
      this.detailSignDilazione.email = null
      this.viewDialogDetailSignDilazione = true
    },

    openConfirmDeleteSignDilazione(dilazioneId){
      this.detailSignDilazione.id = dilazioneId
      this.detailSignDilazione.nominativo = null
      this.detailSignDilazione.contatto = null
      this.detailSignDilazione.email = null
      this.viewConfirmDeleteSignDilazione = true
    },

    getDataStatusDilazione(dilazione){
      let type_data = 'data_' + (this.types_stato.find(type => type.stato == dilazione.cod_status_pratica).type_data)
      return dilazione[type_data]
    },

    sendSignRequestDilazione(detailDilazione){
      this.viewDialogDetailSignDilazione = false
      this.dataLoading = true
      this.isDisableSignPdf = true

      this.service.sendSignRequestDilazione(detailDilazione)
      .then((res) => {
        let severity = res.items.success ? 'success' : 'error'
        let summary = res.items.success ? 'Successo' : 'Attenzione'
        let detail = res.items.errore == '' ? 'Richiesta di firma inviata correttamente' : res.items.errore
        
        this.$toast.add({severity: severity, summary: summary, detail: detail, life: 5000})
        if (!res.items.success) {
          this.isDisableSignPdf = false
        } else {
          this.setNewStatusPdfDilazione(detailDilazione.id, 2, res.items.cod_richiesta_firma)
        }
      })
      .finally(() => {
        this.detailSignDilazione.id = null
        this.detailSignDilazione.nominativo = null
        this.detailSignDilazione.contatto = null
        this.detailSignDilazione.email = null
        this.dataLoading = false
      })
    },

    setNewStatusPdfDilazione(dilazioneId, newStatus, cod_richiesta_firma = null){      
      let dilazione_index = this.data.filtered.findIndex(item => item.id == dilazioneId)      
      if (dilazione_index != -1) {                
        let stato_documento = this.types_stato.find(stato => stato.stato == newStatus)
        
        this.data.filtered[dilazione_index][`data_${stato_documento.type_data}`] = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        this.data.filtered[dilazione_index].cod_status_pratica = newStatus
        this.data.filtered[dilazione_index].stato_documento = stato_documento.name
        if (cod_richiesta_firma) {
          this.data.filtered[dilazione_index].cod_richiesta_firma = cod_richiesta_firma
        }
        if (newStatus == 2) {
          this.data.filtered[dilazione_index].contatto = this.detailSignDilazione.contatto
          this.data.filtered[dilazione_index].email_firma = this.detailSignDilazione.email
          this.data.filtered[dilazione_index].nominativo = this.detailSignDilazione.nominativo
        }
      }
    },

    sendDeleteSignRequestDilazione(detailDilazione){
      this.viewConfirmDeleteSignDilazione = false
      this.dataLoading = true
      this.isDisableDeleteSign = true

      this.service.sendDeleteSignRequestDilazione(detailDilazione, this.user)
      .then((res) => {
        let severity = res.items.error ? 'error' : 'success'
        let summary = res.items.error ? 'Attenzione' : 'Successo'
        let detail = res.items.response
        
        this.$toast.add({severity: severity, summary: summary, detail: detail, life: 5000})
        if (res.items.error) {
          this.isDisableDeleteSign = false
        } else {
          this.setNewStatusPdfDilazione(detailDilazione.id, 4)
        }
      })
      .finally(() => {
        this.detailSignDilazione.id = null
        this.detailSignDilazione.nominativo = null
        this.detailSignDilazione.contatto = null
        this.detailSignDilazione.email = null
        this.dataLoading = false
      })
    },

    downloadPdf(dilazioneId, type_doc = 'dilazione'){
      this.service.downloadPdf(dilazioneId, type_doc)
    },

    changeStatusDilazione(dilazione, status){
      this.dataLoading = true
      this.service.changeStatusDilazione(dilazione.id, status)
      .then((res) => {
        let severity = res.item.success ? 'success' : 'warn' 
        let detail = `${res.item.msg}`
        this.$toast.add({severity: severity, summary: '', detail: detail, life: 5000})
      })
      .finally(() => {
        if (!this.view_all) {
          let id_filtered = this.data.filtered.findIndex(filter => filter.id == dilazione.id)
          this.data.filtered.splice(id_filtered, 1)
          if(this.selectedClients.length == 1){
            let id_cliente = dilazione.cliente.id
            let index = this.selectedClients.findIndex(client => client.id == id_cliente)
            this.selectedClients.splice(index, 1)
          }
        } else {
          let obj_status = this.type_state.find(type => type.id == status)

          dilazione.active = obj_status.id
          dilazione.color = obj_status.color
          dilazione.name_state = obj_status.name
        }
        this.dataLoading = false
      })
    },

    onBollettiniPostaliDilazione(dilazioneId){
      this.service.downloadBollettiniPostali(dilazioneId)
    },

    openDialogMailDilazioni(dilazione){
      let searchTypeMail = dilazione.stato_fornitura == 'Cessata' ? 'Cessata' : 'all'
      
      this.typesMailDilazione = this.allTypesMailDilazione.filter(type => type.for.includes(searchTypeMail))

      this.addMailsToList(dilazione)
      this.tempDilazioneMail = dilazione
      this.dialogDilazioniMail = true
    },

    addMailsToList(dilazione){
      dilazione.type_comunication = 'email'
      this.mailsDilazione = []
      if ('cliente' in dilazione) {
        if ('email' in dilazione.cliente && dilazione.cliente.email != '') {
          this.mailsDilazione.push({to: dilazione.cliente.email})
        }
        if ('pec' in dilazione.cliente && dilazione.cliente.pec != '') {
          this.mailsDilazione.push({to: dilazione.cliente.pec})
        }
      }
    },

    sendMailDilazione(){
      this.dataLoading = true
      this.service.sendMailDilazione(this.tempDilazioneMail)
      .then((res) => {
        if (res.item) {
          this.$toast.add({severity: 'success', summary: 'Successo', detail: 'Email inviata', life: 3000})
        } else {
          this.$toast.add({severity: 'error', summary: 'Errore', detail: 'Errore nell\'invio della email', life: 3000})
        }
      })
      .finally(() => {
        this.dataLoading = false
      })
    },

    navigateToTab(href){
      window.open(href, '_blank')
    },

    applyFilter(filter){
      const length = filter.trim().length
      if(length == 0){
        this.data.filtered = [...this.data.dilazioni]
        return
      }
      if(length > 2){
        this.data.filtered = this.data.dilazioni.filter((el) => el.cliente.ragsoc.toUpperCase().indexOf(filter.toUpperCase()) >= 0)
        return
      }
    },

    getAllDilazioni(){
      if (this.selectedClients.length > 0 && this.service) {
        this.dataLoading = true
        this.service.getAllDilazioni(this.selectedClients, this.view_all)
        .then((res) => {
          const processedDilazioni = res.items.map((el) => {
            el.type_mail_dilazione = this.allTypesMailDilazione[0].label
            el.creata_da = this.formatCreatorDisplay(el)
            let pagato = el.pagato
            el.rate = el.rate.map((rata) => {
              pagato -= rata.importo
              rata.isPagato = (pagato >= -0.10)

              return rata
            })

            return el
          })

          const uniqueDilazioni = processedDilazioni.filter((dilazione, index, self) => 
            index === self.findIndex(d => d.id === dilazione.id)
          )

          this.data.dilazioni = uniqueDilazioni
          this.data.filtered = [...this.data.dilazioni]
        })
        .finally(() => {
          this.dataLoading = false
        })
      } 
    },

    normalizeCreatorRole(role){
      const normalizedRole = String(role || '').toLowerCase()

      if (['agent', 'agente'].includes(normalizedRole)) {
        return 'agente'
      }

      if (['user', 'utente'].includes(normalizedRole)) {
        return 'user'
      }

      return null
    },

    getCreatorTypeLabel(dilazione){
      if (dilazione.creata_da_tipo) {
        return dilazione.creata_da_tipo
      }

      const role = this.getCreatorRole(dilazione)

      if (role === 'agente') {
        return 'Agente'
      }

      if (role === 'user') {
        return 'Utente admin'
      }

      return ''
    },

    formatCreatorDisplay(dilazione){
      const creatorName = String(dilazione.creata_da || '').trim()
      const creatorType = this.getCreatorTypeLabel(dilazione)

      if (creatorName && creatorType) {
        return `${creatorType} - ${creatorName}`
      }

      if (creatorName) {
        return creatorName
      }

      return this.getCreatorFallback(dilazione)
    },

    getCreatorRole(dilazione){
      return this.normalizeCreatorRole(
        dilazione.user_role ||
        dilazione.userRole ||
        dilazione.created_by_role ||
        dilazione.createdByRole ||
        dilazione.role
      )
    },

    getCreatorId(dilazione){
      return dilazione.user_id ||
        dilazione.userId ||
        dilazione.id_user ||
        dilazione.cod_user ||
        dilazione.created_by_id ||
        dilazione.createdById ||
        dilazione.created_by ||
        dilazione.createdBy
    },

    getCreatorFallback(dilazione){
      const role = this.getCreatorRole(dilazione)
      const id = this.getCreatorId(dilazione)

      if (!role || !id) {
        return 'Non disponibile'
      }

      return `${role === 'agente' ? 'Agente' : 'Utente admin'} #${id}`
    },

    getTypeStateDilazioni(){
      this.service.getTypeStateDilazioni()
      .then(res => {
        this.type_state = res.items        
      })
    },

    openFornitureDialog(row) {
      this.selectedFornitureRow = row
      this.viewFornitureDialog = true
    },
  },
}
</script>

<style scoped>
.box-center{
  text-align: center;
}
</style>